import React, { useEffect, useState } from "react";
import { loadReferenceData } from "../../api/referenceData";

const API = process.env.REACT_APP_API_URL || "";

// Libellé + lien de chaque carte, dans l'ordre d'affichage. Les deux stats
// de la maquette d'origine sans équivalent en base ("suggestions refusées",
// "documents archivés") sont volontairement omises plutôt qu'approximées.
const CARDS = [
  { key: "suggestionsNonTraitees", label: "Suggestions non traitées", href: "/", color: "#000091" },
  { key: "fichesEnEtude", label: "Fiches en étude", href: "/fiches", color: "#000091" },
  { key: "fichesTransmises", label: "Fiches transmises à la CELF", href: "/fiches", color: "#000091" },
  { key: "fichesPubliees", label: "Fiches publiées", href: "/fiches", color: "#2fb344" },
  { key: "fichesAbandonnees", label: "Fiches abandonnées", href: "/fiches", color: "#d63939" },
  { key: "fichesAnnulees", label: "Fiches annulées", href: "/fiches", color: "#d63939" },
];

export default function DashboardPage() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${API}/api/custom/dashboard-stats`)
      .then((res) => res.json())
      .then(setStats)
      .catch((e) => console.error("Erreur chargement des statistiques", e))
      .finally(() => setLoading(false));
  }, []);

  // Pré-charge les référentiels (collèges, domaines, langues...) utilisés
  // par creation_fiche, pour que le select soit déjà rempli en arrivant
  // sur cette page (cf. App.js : le Dashboard est toujours la 1re page).
  useEffect(() => {
    loadReferenceData();
  }, []);

  return (
    <div className="admin-page">
      <div className="admin-page-header">
        <h2 style={{ margin: 0 }}>Accueil</h2>
      </div>

      <div className="row row-deck row-cards">
        {CARDS.map((c) => (
          <div className="col-sm-6 col-lg-4" key={c.key}>
            <a href={c.href} className="card" style={{ textDecoration: "none", borderTop: `3px solid ${c.color}` }}>
              <div className="card-body">
                <div className="subheader">{c.label}</div>
                <div className="h1 mb-0" style={{ color: "#1e293b" }}>
                  {loading ? "…" : (stats?.[c.key] ?? "—")}
                </div>
              </div>
            </a>
          </div>
        ))}
      </div>
    </div>
  );
}
